const getStoreData = sessionKey => sessionStorage.getItem(sessionKey);

export const setStoreData = (sessionKey, obj) => sessionStorage.setItem(sessionKey, obj);

export const removeStoreData = sessionKey => sessionStorage.removeItem(sessionKey);

export default getStoreData;
